import './PasswordBadge.css';

import React, { type FC } from 'react';

interface PasswordBadgeInterface {
  onClick: () => void
}

export const PasswordBadge: FC<PasswordBadgeInterface> = ({ onClick }) => {
  return (
    <div className='password_badge' >
      <p>Enter your system password for a recently added device</p>
      <a onClick={onClick}>Enter Now</a>
    </div>
  );
};
